import { SubscribeButton, SubscribeCancelButton } from "components/pay/PayContext";
import { Plan, User } from "components/types/Types";
import { usePermissionContext } from "context/Permission";
import { useEffect, useState } from "react";
import Button from "./Button";
import Contact from "./Contact";
import TranslucencyMask from "./TranslucencyMask";
import CustomImage from "components/common/CustomImage";

// 账号信息
export default function Account(props: { user: User, planList: Plan[], cancel: Function}){
    const {user, planList, cancel} = props;
    const permissionContext = usePermissionContext();
    const [isContact, setIsContact] = useState<boolean>(false);
    const [currentPlan, setCurrentPlan] = useState<Plan>();

    useEffect(() => {
        if(planList){
            let plan = planList[0];
            for(let i = 0, len = planList && planList.length || 0 ;i < len ;i ++){
                const item = planList[i];
                if(item.id === user.planId){
                    plan = item ;
                }
            }
            setCurrentPlan(plan);
        }
    }, [ planList ])

    const ctime = (time: string | undefined) => {
        return time && time.substring(0,10) || ''
    }

    return (
        <>
            <TranslucencyMask className="z-[10009]" closeHandler={() => {cancel()}}>
                <div className="absolute xl:w-[780px] w-[70%] max-h-[85%] overflow-y-auto left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] p-[30px] bg-[#ffffff] rounded-[15px]"
                    onClick={(e) => e.stopPropagation()}>
                    <CustomImage src="/icon/icon-close.png" className="absolute right-[30px] top-[30px] w-[30px] cursor-pointer" 
                        onClick={() => {cancel()}}/>

                    <div className="flex items-center gap-[10px] py-[10px] px-[30px]">
                        <span className="flex items-center justify-center w-[50px] h-[50px] rounded-full bg-[#e4e5e7] medium-txt">{user.name?.substring(0,2).toLocaleUpperCase()}</span>
                        <span className="text-[20px] font-semibold">{user.name}</span>
                    </div>
                    <div className="flex items-center mt-[3px] pl-[30px] pr-[10px] py-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <CustomImage src="/icon/icon-email.png" className="w-[25px]" />
                            <span className="medium-txt font-semibold">Email address</span>
                        </div>
                        <span className="grow text-right font-medium small-txt">{user.email}</span>
                    </div>
                    <div className=" mt-[10px] pl-[30px] py-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <CustomImage src="/icon/icon-plans.png" className="w-[25px]" />
                            <span className="medium-txt font-semibold">Plans</span>
                        </div>
                    </div>
                    <div className="pl-[60px] pr-[30px]">
                        <div className="py-[14px]">
                            <span className="medium-txt font-semibold">Subscription</span>
                        </div>
                        <div className="py-[14px] flex items-center">
                            {
                                currentPlan && currentPlan.price > 0 ? 
                                <>
                                    <span className="small-txt w-[50%]">{currentPlan.name}</span>
                                    <span className="grow small-txt">$ {currentPlan.price}/mo</span>
                                </>
                                : <span className="small-txt grow">{currentPlan && currentPlan.name || 'Loading'}</span>
                            }
                            <Button txt="Change" clickEvent={() => permissionContext?.upgrade() }></Button>
                        </div>
                        <div className="py-[14px] flex items-center">
                            <span className="small-txt w-[50%]">Subscription Date</span>
                            <span className="small-txt text-center">{ctime(user.subscribeTime)}</span>
                        </div>
                        {
                            currentPlan && currentPlan.price > 0 && 
                            <div className="py-[14px] flex items-center">
                                <div className="flex flex-col gap-[5px] w-[50%]">
                                    <span className="small-txt">Expiry Date</span>
                                    <span className="small-txt text-[#787878]">Auto-renewal is { user.subscribeStatus == 1 ? 'enabled' : 'cancelled'}.</span>
                                </div>
                                <span className="grow small-txt">{ctime(user.expireTime)}</span>
                                {
                                    user.subscribeStatus == 1 ?
                                        <SubscribeCancelButton />
                                    :
                                        <SubscribeButton plan={currentPlan} txt="Renew now" />
                                }  
                                
                            </div>
                        }

                        <div className="py-[14px]">
                            <span className="medium-txt font-semibold">Credits</span>
                        </div>
                        <div className="py-[14px] flex items-center">
                            <div className="flex flex-col gap-[5px] grow">
                                <span className="small-txt">{currentPlan && currentPlan.creditValue || 0} Credits</span>
                                <span className="small-txt text-[#787878]">Automatically refreshes when it expires each {currentPlan && currentPlan.creditCycle == 1 ? 'week' : 'month'}.</span>
                            </div>
                            <Button txt="Change" clickEvent={() => permissionContext?.upgrade() }></Button>
                        </div>
                        <div className="py-[14px] flex items-center">
                            <div className="flex flex-col gap-[5px] grow">
                                <span className="small-txt ">0 Free Access Credits</span>
                                <span className="small-txt text-[#787878]">Credits earned and purchased for free do not expire.</span>
                            </div>
                            <Button txt="Get credits" clickEvent={() => window.open('https://www.mockuplabs.ai/resources/rules')}></Button>
                        </div>
                        <div className="py-[14px] flex items-center">
                            <span className="small-txt grow">Get More Credits</span>
                            <Button txt="Contact us" clickEvent={() => setIsContact(true)}></Button>
                        </div>
                    </div>
                </div>
            </TranslucencyMask>
            {
                isContact && <Contact cancel={() => setIsContact(false)} />
            }
        </>
    )
}